import PropTypes from 'prop-types';
import { Box, Typography, Chip } from '@mui/material';
import { Business as OrgIcon } from '@mui/icons-material';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';
import { useAuth } from 'contexts/AuthContext';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  const { user } = useAuth();
  const orgName = user?.organization?.orgName || user?.organizationName;

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: orgName && open ? '90px' : '60px',
        width: 'initial',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: open ? '24px' : 0,
        paddingRight: open ? '24px' : 0,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Logo isIcon={!open} sx={{ width: open ? 'auto' : 35, height: 35 }} />
      {open && orgName && (
        <Chip
          icon={<OrgIcon sx={{ fontSize: 14 }} />}
          label={orgName}
          size="small"
          variant="outlined"
          color="primary"
          sx={{ 
            mt: 1.5,
            fontSize: '0.75rem',
            height: 26,
            '& .MuiChip-icon': {
              ml: 0.5
            }
          }}
        />
      )}
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
